<template>
  <div class="br-modal">
    <div class="br-modal__dialog">
      <div class="br-modal__head">
        <span class="br-modal__title">Newsletter Unsubscribe</span>
        <button
          v-modal
          class="button button--icon js-close-modal">
          <i class="icon icon-e-remove"/>
        </button>
      </div>
      <div class="br-modal__body">
        <div
          v-if="message !== ''"
          class="notice">
          <div class="notice__icon">
            <i class="icon icon-check"/>
          </div>
          <div class="notice__content">
            <p>{{ message }}</p>
          </div>
        </div>
        <div
          v-else
          class="notice">
          <div class="notice__icon">
            <i class="icon icon-question"/>
          </div>
          <div class="notice__content">
            <p>Are you sure you would like to turn off your Newsletter Subscription?</p>
          </div>
        </div>
      </div>
      <div
        v-if="message === ''"
        class="br-modal__foot"
        style="justify-content: flex-end">
        <button-loader v-if="loading"/>
        <button
          class="button u-border-radius u-margin-right-s"
          @click="sendUnsubscribe">
          Yes
        </button>
        <button
          v-modal
          class="button button--danger u-border-radius js-close-modal">
          No
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ModalMixin from '@mixins/ModalMixin'

export default {
  mixins: [
    ModalMixin
  ],
  data: () => ({
    loading: false,
    message: ''
  }),
  methods: {
    async sendUnsubscribe () {
      this.loading = true
      this.response = await axios.post('unsub-newsletter', { ...this.modalParams, action: 'yes' })
      this.message = this.response.data
      this.loading = false
    }
  }
}
</script>
